/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Missing_Items_InvalidInputs */

const en_error_missing_items_invalid = /** @type {(inputs: Error_Missing_Items_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The choice for the missing units cannot be accepted.`)
};

/**
* | output |
* | --- |
* | "The choice for the missing units cannot be accepted." |
*
* @param {Error_Missing_Items_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_missing_items_invalid = /** @type {((inputs?: Error_Missing_Items_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Missing_Items_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_missing_items_invalid(inputs)
});